import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router, RouterOutlet} from '@angular/router';
import {FuseNavigationService, FuseVerticalNavigationComponent} from '@fuse/components/navigation';
import {FuseMediaWatcherService} from '@fuse/services/media-watcher';
import {NavigationService} from 'app/core/navigation/navigation.service';
import {Navigation} from 'app/core/navigation/navigation.types';
import {Subject, takeUntil} from 'rxjs';
import {QuickChatComponent} from '../../../common/quick-chat/quick-chat.component';
import {UserComponent} from '../../../common/user/user.component';
import {NotificationsComponent} from '../../../common/notifications/notifications.component';
import {MessagesComponent} from '../../../common/messages-old/messages.component';
import {ShortcutsComponent} from '../../../common/shortcuts-old/shortcuts.component';
import {FuseFullscreenComponent} from '@fuse/components/fullscreen/fullscreen.component';
import {LanguagesComponent} from '../../../common/languages-old/languages.component';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {FuseHorizontalNavigationComponent} from '@fuse/components/navigation/horizontal/horizontal.component';
import {
    FuseVerticalNavigationComponent as FuseVerticalNavigationComponent_1
} from '@fuse/components/navigation/vertical/vertical.component';
import {NgIf} from '@angular/common';
import {FuseLoadingBarComponent} from '@fuse/components/loading-bar/loading-bar.component';
import { TutorialService } from '@shared/services/tutorial.service';

@Component({
    selector: 'modern-layout',
    templateUrl: './modern.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [FuseLoadingBarComponent, NgIf, FuseVerticalNavigationComponent_1, FuseHorizontalNavigationComponent, MatButtonModule, MatIconModule, LanguagesComponent, FuseFullscreenComponent, ShortcutsComponent, MessagesComponent, NotificationsComponent, UserComponent, RouterOutlet, QuickChatComponent]
})
export class ModernLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    navigation: Navigation;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        public tutorialService: TutorialService
    ) {
    }

    get currentYear(): number {
        return new Date().getFullYear();
    }


    ngOnInit(): void {
        // Subscribe to navigation data
        this._navigationService.navigation$
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((navigation: Navigation) => {
            this.navigation = navigation;
        });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe(({ matchingAliases }) => {

            // Check if the screen is small
            this.isScreenSmall = !matchingAliases.includes('md');
        });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    toggleNavigation(name: string): void {
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);
        if (navigation) {
            navigation.toggle();
        }
    }
}
